import * as yup from 'yup'

export class DamagePhoto2Dto {
  damagePhoto2FileName?: string = undefined
  damagePhoto2File?: File | string = undefined
}

export const DamagePhoto2DtoSchema = yup.object({
  damagePhoto2FileName: yup.string().nullable(),
  damagePhoto2File: yup.mixed()
})
